var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import * as React from "react";
import { connect } from "react-redux";
import ApiRequests from "../../classes/http/ApiRequests";
import HttpRequests from "../../classes/http/HttpRequests";
import RefreshsReduxProps from "./RefreshsReduxProps";
var Refreshs = /** @class */ (function (_super) {
    __extends(Refreshs, _super);
    function Refreshs() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.api = new ApiRequests();
        _this.http = new HttpRequests();
        _this.messages = null;
        _this.state = {
            data: [],
            meta: null,
            refresh_message: null,
            buttonDisabled: false
        };
        _this.refreshButtonStatus = function () {
            _this.api.getRefreshButtonStatus()
                .then(function (response) {
                if (response.data.status === 'in_progress') {
                    _this.setState({ buttonDisabled: true });
                }
            }).catch(function (err) {
                _this.setState({
                    refresh_message: err.response.data.message,
                });
            });
        };
        _this.resenderRefreshButtonStatus = function () {
            _this.setState({ buttonDisabled: true });
            _this.api.resenderRefreshButton()
                .then(function (response) {
                _this.setState({
                    buttonDisabled: true,
                    refresh_message: response.data.message
                });
            }).catch(function (err) {
                _this.setState({
                    refresh_message: err.response.data.message + ' ' + err.response.data.errors[0],
                });
            });
        };
        // Deleting the item from the state
        _this.deleteItem = function (id) {
            var data = __spreadArrays(_this.state.data);
            var result = data.find(function (item) {
                return item.Id === id;
            });
            var index = data.indexOf(result);
            data.splice(index, 1);
            _this.setState({ data: data });
        };
        return _this;
    }
    Refreshs.prototype.componentDidMount = function () {
        this.refreshButtonStatus();
    };
    Refreshs.prototype.render = function () {
        var _this = this;
        var data = this.state.data;
        return (React.createElement("div", { className: "container-fluid" },
            React.createElement("div", { className: "animated fadeIn" },
                React.createElement("h1", { className: "display-3" }, "\u041E\u0431\u043D\u043E\u0432\u044F\u0432\u0430\u043D\u0435"),
                React.createElement("hr", null),
                React.createElement("div", { className: "row" },
                    React.createElement("div", { className: "col-md-12" },
                        React.createElement("div", { className: "list-actions" },
                            React.createElement("button", { disabled: this.state.buttonDisabled, className: "btn btn-sm btn-primary", style: { marginBottom: 20 }, onClick: function () { return _this.resenderRefreshButtonStatus(); }, type: "button" },
                                React.createElement("i", { className: "fa fa-dot-circle-o" }),
                                " \u041E\u0431\u043D\u043E\u0432\u0438")),
                        React.createElement("div", null,
                            React.createElement("p", null, this.state.refresh_message)))))));
    };
    return Refreshs;
}(React.Component));
export default connect(null, RefreshsReduxProps.mapDispatchToProps)(Refreshs);



//////////////////
// WEBPACK FOOTER
// ./src/views/Refreshs/Refreshs.tsx
// module id = 421
// module chunks = 0